import packageApi from '../../api/package.api.js'

const state = {
	siteCount: {},
	ftps: [],
	currentFtp: {},
	isNeedCreateNsy: true,
	domain: '',
	xip: ''
}

const getters = {

}

const mutations = {
	setPackageState(state, data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				state[key] = data[key]
			}
		}
	},
}

const actions = {
	// 获取所有套餐列表
	getPackageList() {
		return packageApi.packageList()
	},
	// 获取用户的空间数量
	getFtpCount() {
		return packageApi.getFtpCount()
	},

	/**
	 * 域名校验
	 * 成功后判断 isNeedCreateNsy 这个字段去判断 是否需要调用查询用户可以使用的牛商云空间列表这个接口 获取detailId
	 * @param data {Object}
	 * @param data.domain {String}
	 * @param data.projectId {String}
	 * @returns {*}
	 */
	checkMineDomain(context, data) {
		return packageApi.checkMineDomain(data).then(res => {
			return res.data
		})
	},

	/**
	 * 查询用户可以使用的牛商云空间列表
	 * @param data {Object}
	 * @param data.projectId {String}
	 * @returns {*}
	 */
	checkAndGetFtp(context, data) {
		return packageApi.checkAndGetFtp(data).then(res => {
			return res.data
		})
	},

	/**
	 * 校验成功后获取牛商云ip
	 * @param data {Object}
	 * @param data.projectId {String}
	 * @param data.detailId {String} -不是必传 isNeedCreateNsy为flase不用传入
	 * @returns {*}
	 */
	ipAddress(context, data) {
		return packageApi.ipAddress(data).then(res => {
			return res.data
		})
	},

	/**
	 * 最后一步 解析
	 * @param data {Object}
	 * @param data.domain {String}
	 * @param data.projectId {String}
	 * @returns {*}
	 */
	analysis(context, data) {
		return packageApi.analysis(data).then(res => {
			return res.data
		})
	},
	/**
	 *  留下手机号码
	 * @param data {Object}
	 * @param data.projectId {String}
	 * @param data.uid {String}
	 * @param data.mobile {String}
	 * @param data.errorStatus {String}
	 * @param data.errorMessage {String}
	 * @returns {*}
	 */
	leaveMessage(context, data) {
		return packageApi.leaveMessage(data).then(res => {
			return res.data
		})
	}

}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
